import {combineReducers} from 'redux';

import GlobalStore from './globalStore';
import UserStore from './userStore';

export default combineReducers ({
  GlobalStore,
  UserStore
});
